import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import AmountPriceContainer from '@configuratorware/configurator-frontendgui/App/Screens/Configurator/Containers/AmountPrice';
import AmountPrice from '../../Components/AmountPrice/AmountPrice';
import { fetchSummary } from '../../Reducers/Menu/Actions';

const CustomAmountPriceContainer = (props) => {
  const dispatch = useDispatch();
  const { summary } = useSelector((state) => state.menu);
  return (
    <AmountPriceContainer
      {...props}
      Component={AmountPrice}
      fetchSummary={() => dispatch(fetchSummary())}
      summary={summary}
    />
  );
};

export default CustomAmountPriceContainer;
